/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Aviso de trust en Inicio (no chrome global — no tapa POS/tabs).
 */
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { spacing } from '../../../shared/theme/spacing';
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';
import {
  trustStatusHomeTeaser,
  trustStatusTitle,
  type OrgTrustStatus,
} from '../../../settings/infra/orgTrustStatusService';

type Props = {
  trust: OrgTrustStatus | null;
  onPressDetail: () => void;
};

export function MarketplaceTrustBanner({ trust, onPressDetail }: Props) {
  if (!trust) return null;
  if (
    trust.status !== 'warned' &&
    trust.status !== 'restricted' &&
    trust.status !== 'suspended' &&
    trust.status !== 'banned'
  ) {
    return null;
  }

  const severe =
    trust.status === 'restricted' ||
    trust.status === 'suspended' ||
    trust.status === 'banned';

  return (
    <TouchableOpacity
      style={[styles.row, severe ? styles.rowSevere : styles.rowWarn]}
      onPress={onPressDetail}
      accessibilityRole="button"
      accessibilityLabel={`${trustStatusTitle(trust.status)}. Ver el aviso`}
    >
      <Ionicons
        name={severe ? 'warning-outline' : 'information-circle-outline'}
        size={18}
        color={severe ? '#B45309' : ticketColors.gold}
      />
      <View style={styles.textCol}>
        <Text style={styles.title}>{trustStatusTitle(trust.status)}</Text>
        <Text style={styles.body}>{trustStatusHomeTeaser(trust.status)}</Text>
        <Text style={styles.ctaHint}>Ver el aviso</Text>
      </View>
      <Ionicons name="chevron-forward" size={18} color={ticketColors.ink2} />
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: spacing.sm,
    paddingVertical: 12,
    paddingHorizontal: spacing.md,
    borderRadius: 14,
    borderWidth: 1,
  },
  rowWarn: {
    borderColor: ticketColors.gold,
    backgroundColor: ticketColors.brandSoft,
  },
  rowSevere: {
    borderColor: '#F0C4C4',
    backgroundColor: '#FDECEC',
  },
  textCol: { flex: 1, minWidth: 0, gap: 2, paddingTop: 1 },
  title: {
    fontSize: 14,
    fontWeight: '700',
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },
  body: {
    fontSize: 12,
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
    lineHeight: 17,
  },
  ctaHint: {
    marginTop: 2,
    fontSize: 12,
    fontWeight: '600',
    color: ticketColors.gold,
    fontFamily: ticketFonts.sans,
  },
});
